<template>
  <div>
    <CustomPageHeaderVue>{{ $t('news_list_title') }}</CustomPageHeaderVue>
    <CustomRow style="height: 100%">
      <v-overlay :opacity="0.6" v-model="showPopup" z-index="6">
        <v-dialog v-model="showPopup" max-width="1000" hide-overlay>
          <v-img :src="popupImg">
            <v-icon @click="showPopup = false" class="ma-2 float-right" color="white">mdi-close</v-icon>
          </v-img>
        </v-dialog>
      </v-overlay>

      <v-card class="pa-5 my-5" v-if="campaign.title" style="height: calc(100% - 20px)">
        <article>
          <h4 class="font-weight-bold">
            {{ campaign.title }}
          </h4>
          <div class="grey--text mt-1">{{ campaign.time }}</div>
          <v-divider class="my-3"></v-divider>
          <div @click="clickNewsContent" v-html="campaign.content" class="news-content my-5"></div>
        </article>

      </v-card>
      <v-card v-else class="pa-5 my-5 text-center">
        <ProgressCircular />
      </v-card>
    </CustomRow>
  </div>
</template>

<script>
import { getNews } from "@/api/static";
import CustomPageHeaderVue from "@/components/CustomPageHeader.vue";

export default {
  components: {
    CustomPageHeaderVue
  },
  data() {
    return {
      campaign: {},
      popupImg: "",
      showPopup: false
    };
  },
  metaInfo() {
    return {
      title: `${this.campaign.title || ''} - ${this.$t('app_name')}`,
      meta: [
        {
          property: 'og:title',
          content: `${this.campaign.title || ''} - ${this.$t('app_name')}`,
          vmid: 'og:title'
        }, {
          property: 'og:url',
          content: window.location.href,
          vmid: 'og:url'
        }
      ],
      script: [{
        type: 'application/ld+json',
        json: {
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": `${this.campaign.title || ''} - ${this.$t('app_name')}`,
          "url": window.location.href
        }
      }]
    }
  },
  watch: {
    showPopup(val) {
      if (val) {
        document.documentElement.style.overflow = "hidden";
        document.body.scroll = "no";
      } else {
        document.documentElement.style.overflow = "scroll";
        document.body.scroll = "yes";
      }
    }
  },
  mounted() {
    getNews().then(res => {
      this.campaign = res.data.news.find(
        c => c.news_id == this.$route.params.id
      );
      this.$store.dispatch("setOverlayLoading", false);
      this.$gtm.trackView(`News：${this.campaign.title}`, this.$route.path);
    });
  },
  methods: {
    clickNewsContent(e) {
      if (e.target.nodeName === "IMG") {
        this.showPopup = true;
        this.popupImg = e.target.src;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .news-content {
  img {
    width: 100%;
    max-width: 633px;
    margin: auto;
    display: flex;
    cursor: zoom-in;
  }
}
</style>
